import { createContext, useEffect, useReducer, useContext, useState } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getPathName } from "../../../common/utils/utilsFunc";

export const ConsultSubsidyContext = createContext();
export const ACTIONS = {
  SET_SERV1: "SET_SERV1",
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_RESPONSE_SERV1: "SET_RESPONSE_SERV1",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_WEB_CONTENT_TEXT_RESPONSE_SUCCESS: "SET_WEB_CONTENT_TEXT_RESPONSE_SUCCESS",
  SET_WEB_CONTENT_TEXT_RESPONSE_FAIL: "SET_WEB_CONTENT_TEXT_RESPONSE_FAIL",

};
const initialState = {
  serv1: null,
  response_serv1: null,
  detailClient: null,
  webContentTextInfo: "",
  webContentTextResponseSuccess: "",
  webContentTextResponseFail: "",
  idClient: ""

};
const ConsultSubsidyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload
      };
    }
    case ACTIONS.SET_SERV1: {
      return {
        ...state,
        serv1: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idClient: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_SERV1: {
      return {
        ...state,
        response_serv1: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_RESPONSE_SUCCESS: {
      return {
        ...state,
        webContentTextResponseSuccess: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_RESPONSE_FAIL: {
      return {
        ...state,
        webContentTextResponseFail: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const ConsultSubsidyContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(ConsultSubsidyReducer, initialState);

  useEffect(() => {
    if (getPathName() === 'subsidio-y-beneficios-para-deudas-por-consumos-de-energia-en-pandemia') {
      if (state.serv1) {
        dispatch({
          payload: state.serv1,
          type: ACTIONS.SET_IDCLIENT,
        });
        LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.serv1, properties.url_ws_empresa, properties.codigo_empresa)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_DETAIL_CLIENT,
            });
            if (response.ConsultarDetalleCtaCtoResponse.RETORNO.RETURN === 0) {
              LiferayService.consultSubsidy(properties.base_url_api, state.serv1, properties.url_ws_empresa, properties.codigo_empresa)
                .then((response) => {
                  dispatch({
                    payload: response,
                    type: ACTIONS.SET_RESPONSE_SERV1,
                  });
                  dispatch({
                    payload: "",
                    type: ACTIONS.SET_SERV1,
                  });
                })
            } else {
              dispatch({
                payload: "",
                type: ACTIONS.SET_SERV1,
              });
            }
          })
      }
    }
  }, [state.serv1]);

  useEffect(() => {
    if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
    }
    if (decode_utf8(properties.web_content_return_success_subsidy)?.trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_return_success_subsidy).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_RESPONSE_SUCCESS,
          });
        })
    }
    if (decode_utf8(properties.web_content_return_fail_subsidy)?.trim()) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_return_fail_subsidy).trim())
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_RESPONSE_FAIL,
          });
        })
    }

  }, [])

  return (
    <ConsultSubsidyContext.Provider value={[state, dispatch]}>
      {children}
    </ConsultSubsidyContext.Provider>
  );
};

export default ConsultSubsidyContextProvider;